import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  deleteItemUnitApi,
  getItemUnitApi,
  saveUnitManageApi,
} from "../../apiservice/inventory";
// fecth Customer credit limit and due balance

export const fetchUnitsList = createAsyncThunk(
  "units/fetchUnitsList",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getItemUnitApi({type: "all"});
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);


// export const fetchCustomersDetails = createAsyncThunk(
//   "customers/fetchCustomersDetails",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await getCustomersCode();
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(
//         error.response ? error.response.data : error.message
//       );
//     }
//   }
// ); 

export const fetchBaseUnitsList = createAsyncThunk(
  "units/fetchBaseUnitsList",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getItemUnitApi({ type: "base_unit" });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const createOrUpdateUnit = createAsyncThunk(
  "units/createOrUpdateUnit",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await saveUnitManageApi(payload);

      if (res.data.error) {
        return rejectWithValue(res.data);
      }

      return res.data;

    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteUnit = createAsyncThunk(
  "units/deleteUnit",
  async (unit_id, { rejectWithValue }) => {
    try {
      const res = await deleteItemUnitApi({ unit_id });
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

